var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0183 2.66748C7.98413 2.66748 5.51829 5.13331 5.51829 8.16748V10.8166C5.51829 11.3758 5.27996 12.2283 4.99579 12.705L3.94163 14.4558C3.29079 15.5375 3.73996 16.7383 4.93163 17.1416C8.88246 18.4616 13.145 18.4616 17.0958 17.1416C18.205 16.775 18.6908 15.4641 18.0858 14.4558L17.0316 12.705C16.7566 12.2283 16.5183 11.3758 16.5183 10.8166V8.16748C16.5183 5.14248 14.0433 2.66748 11.0183 2.66748Z",
    stroke: "#235643",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7142 2.93332C12.43 2.85082 12.1367 2.78665 11.8342 2.74999C10.9542 2.63999 10.1108 2.70415 9.32251 2.93332C9.58834 2.25499 10.2483 1.77832 11.0183 1.77832C11.7883 1.77832 12.4483 2.25499 12.7142 2.93332Z",
    stroke: "#235643",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7683 17.4717C13.7683 18.9842 12.5308 20.2217 11.0183 20.2217C10.2666 20.2217 9.56998 19.91 9.07498 19.415C8.57998 18.92 8.26831 18.2233 8.26831 17.4717",
    stroke: "#235643",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.518e268bab47e978ca36c6ec5d2258f3.svg";
export { ForwardRef as ReactComponent };